export default __webpack_public_path__ + "static/media/17.e56d0d85.jpg";